import { OrganizationService } from "services/OrganizationService";

export interface ExistingTierMatch {
    name: string;
    path: string[];
}

const orgService = new OrganizationService();

export async function findExistingTierPaths(
    name: string,
    excludeId?: string,
): Promise<ExistingTierMatch[]> {
    const trimmed = name.trim();
    if (trimmed.length === 0) return [];

    const matches = await orgService.getServiceHierarchiesByName(trimmed);
    return (excludeId
        ? matches.filter((m) => m.id !== excludeId)
        : matches
    ).map(({ name: matchName, path }) => ({ name: matchName, path }));
}
